import { Box, Typography } from "@mui/material";

export default function ReportTitle({ title, subtitle }) {
  return (
   <Box sx={{ width: "100%", textAlign: "center" }}>
  <Typography variant="h4" fontWeight={700}>
    {title}
  </Typography>

  {subtitle && (
    <Typography variant="subtitle1" color="text.secondary" mt={0.5}>
      {subtitle}
    </Typography>
  )}
</Box>
  );
}